import React from 'react';
import {Button, Popconfirm, Icon, message, Modal, Checkbox, Menu, Dropdown} from 'antd';
import {Link} from 'react-router-dom';
import {observable, toJS} from 'mobx';
import {observer} from 'mobx-react';
import {withRouter} from 'react-router'

import ListTable from '@components/ListTable/ListTable.jsx';

import user_store, {pagination_store, filter_store, ItemStore} from '@store/User/UserList/UserStore';
import user_bet_record_store from '@store/User/UserList/UserBetRecordStore.js';
import update_agent_store from '@store/User/UserList/UpdateAgentStore.js';
import change_user_store from '@store/User/UserList/ChangeUserStore.js';
import login_user_store from '@src/Store/LoginUser/LoginUserStore';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import GoToPage from '@common/GoToPage';

@withRouter
@observer
class UserListTable extends React.Component {

  constructor(props) {
    super();

    let id = props.match.params.id;
    let type = props.match.params.type;
    let username = props.match.params.username;
    this.updateDatas(type, id, username)
  }

  componentWillReceiveProps(nextProps) {

    let id = nextProps.match.params.id;
    let type = nextProps.match.params.type;
    let username = nextProps.match.params.username;
    this.updateDatas(type, id, username);

  }

  updateDatas(type, id, username) {
    user_store.currentUserId = id;
    user_store.currentType = type;

    //刷新页面
    user_store.reloadDatas();
  }

  columns = [
    {
      key: 'pet_name',
      sorter: true,
      title: '昵称',
      dataIndex: 'pet_name'
    },
    {
      key: 'nick_name',
      sorter: true,
      title: '账号',
      dataIndex: 'nick_name',
    },
    {
      key: 'proxy_nick_name',
      sorter: false,
      title: '上级代理',
      render( text, record, index ) {

        if (login_user_store.pet_name == record.proxy_nick_name)
        {
          return (
            <span>
              {record.proxy_nick_name}
          </span>
          )
        }

        return (
          <span onClick={() => {
            // console.log(record);
            GoToPage.goMySummaryPath( record.proxy_id, record.proxy_nick_name )
          }}>
            <a href="#"
               onClick={(event) => {
                 event.preventDefault()}
               }
               className="link-hover">{record.proxy_nick_name}</a>
          </span>
        )
      }
    },
    {
      key: 'pay_money',
      sorter: true,
      title: '本月充值',
      className: 'column-money',
      render(text, record, index) {
        return (
          <a href="#"
            className="link-hover"
            onClick={(event) => {
              event.preventDefault()
            let filter = {
              agent:record.proxy_nick_name,
              search:record.pet_name,
            }
            GoToPage.goRechargePath(filter)
          }}><span>
            {window.FormatAmount(record.pay_money)}
          </span></a>
        )
      }
    },
    // {
    //   key: 'yingkui',
    //   sorter: true,
    //   title: '总输赢',
    //   className: 'column-money',
    //   render(text, record, index) {
    //     let style = undefined;
    //     let title = undefined;

    //     let money = window.FormatAmount(record.yingkui);

    //     if (record.yingkui > 0) {
    //       style = {
    //         color: '#c43827'
    //       };
    //       title = `+${money}`;
    //     }
    //     else if (record.yingkui < 0) {
    //       style = {
    //         color: '#1c9f6d'
    //       };
    //       title = `${money}`;
    //     }
    //     else {
    //       title = `${money}`;
    //     }

    //     return (
    //       <a href="javascript:;"
    //         className="link-hover"
    //          style={style}
    //          onClick={(event) => {
    //               event.preventDefault()
    //         let filter = {
    //           agent:record.proxy_nick_name,
    //           search:record.pet_name,
    //         }
    //         GoToPage.goRakeBackPath(filter)
    //       }}><span>
    //       {title}
    //       </span></a>
    //     )
    //   }
    // },
    {
      key: 'balance',
      sorter: true,
      title: '余额',
      className: 'column-money',
      render(text, record, index) {
        return (
          <span>
            {window.FormatAmount(record.balance)}
          </span>
        )
      }
    },
    {
      key: 'mosaic_gold',
      sorter: true,
      title: '彩金',
      className: 'column-money',
      render(text, record, index) {
        return (
          <span>
            {window.FormatAmount(record.mosaic_gold)}
          </span>
        )
      }
    },
    // {
    //   key: 'user_num',
    //   sorter: true,
    //   title: '推荐会员',
    //   render(text, record, index) {
    //     return (
    //       <Link
    //         className="link-hover"
    //         onClick={() => {
    //           breadcrumb_store.addUserItem(user_store.currentType, record.id, record.pet_name);
    //         }}
    //         to={breadcrumb_store.getUserItemPath(user_store.currentType, record.id, record.pet_name)}
    //       >{record.user_num}</Link>
    //     )
    //   }
    // },
    {
      key: 'last_login_time',
      sorter: true,
      title: '最后登录时间',
      dataIndex: 'last_login_time'
    },
    {
      key: 'reg_time',
      sorter: true,
      title: '注册时间',
      dataIndex: 'reg_time'
    },
    // {
    //   title: '启用',
    //   render(text, record, index) {

    //     return (
    //       <Checkbox
    //         defaultChecked={(record.robot_stauts === 0 ? true : false)}
    //         onChange={async (e) => {
    //           console.log("test", e)
    //           // record.isUsed = e.target.checked
    //           console.log(e.target);
    //           let value = e.target.checked ? 0 : 1;
    //           let result = await user_store.changeLoginStatus(record, value);
    //           if( result.success ) {
    //             message.success(`${record.nick_name} ${e.target.checked ? '启用':'停用'} 成功!`, 3);
    //           } else {
    //             message.error(`${record.nick_name} ${e.target.checked ? '启用':'停用'} 失败! ${ result.error.error_data }`, 3);
    //           }
    //         }}
    //       />
    //     )
    //   }
    // },
    {
      title: '启用常规时间购彩',
      align: 'center',
      render(text, record, index) {

        return (
          <Checkbox
            defaultChecked={(record.is_routine === 1 ? true : false)}
            onChange={async (e) => {
              // record.isUsed = e.target.checked
              let value = e.target.checked ? 1 : 0;
              let result = await user_store.changegetProxyEnable(record, value);
              if( result.success ) {
                message.success(`${record.nick_name} ${e.target.checked ? '启用常规时间购彩成功!':'停用常规时间购彩成功,设置为临场(24小时)购彩!'} `, 3);
              } else {
                message.error(`${record.nick_name} ${e.target.checked ? '启用':'停用'} 常规时间购彩失败! ${ result.error.error_data }`, 3);
              }
            }}
          />
        )
      }
    },
    {
      title: '操作',
      render(text, record, index) {

        const menu = (
          <Menu>
            <Menu.Item>
              <span
                onClick={() => {
                  let filter = {
                    agent:record.proxy_nick_name,
                    search:record.pet_name,
                  }
                  GoToPage.goRechargePath(filter)
                }}
              >充值记录</span>
            </Menu.Item>
            <Menu.Item>
              <span
                onClick={() => {
                  let filter = {
                    agent:record.proxy_nick_name,
                    search:record.pet_name,
                  }
                  GoToPage.goCashPath(filter)
                }}
              >提现记录</span>
            </Menu.Item>
            <Menu.Item>
              <span
                onClick={() => {
                  let filter = {
                    agent:record.proxy_nick_name,
                    search:record.pet_name,
                  }
                  GoToPage.goRakeBackPath(filter)

                  // user_bet_record_store.openModal(record);
                }}
              >投注记录</span>
            </Menu.Item>
            <Menu.Item>
              <span
                onClick={() => {
                  update_agent_store.openModal(record);
                }}
              >提升代理</span>
            </Menu.Item>
            <Menu.Item>
              <span
                onClick={() => {
                  change_user_store.openModal(record);
                }}
              >转移会员</span>
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown
            overlay={menu}
            placement="bottomRight">
            <Icon
              type="setting"
              style={{
                fontSize: '20px'
              }}
              theme="filled"
            />
          </Dropdown>
        )
      }
    },
    // {
    //   title: '操作',
    //   render(text, record, index) {
    //     return (
    //       <Popconfirm
    //         title={`确定 ${record.nick_name} 提升为代理`}
    //         okText="确定"
    //         icon={<Icon type="question-circle-o" style={{color: 'red'}}/>}
    //         onConfirm={
    //           async () => {
    //             let result;
    //             result = await user_store.updateToAgent(record);
    //             if (result.success) {
    //               message.success(` ${record.nick_name} 提升为代理成功！`, 3);
    //               // 重新拉取数据，刷新列表
    //               user_store.searchByFilter();
    //             } else {
    //               message.error(` ${record.nick_name} 提升为代理失败！${ result.error.error_data }`, 3);
    //             }
    //           }
    //         }>
    //         {
    //           // 判断当前权限，确定该显示哪个按钮
    //           <a href="javascript:;">提升为代理</a>
    //         }
    //       </Popconfirm>
    //     )
    //   }
    // }
  ]

  componentDidMount() {
    // user_store.reloadDatas();
  }

  componentWillUnmount() {
    filter_store.resetAttr();
  }

  /**
   * 分页器点击回调
   * @param {number} page
   * @param {number} size
   */
  pagination_callback(page, size, order_by) {
    user_store.searchByFilter({
      page: page,
      page_size: size,
      ...order_by,
    })
  }

  render() {
    return (
      <ListTable
        data_source={toJS(user_store.item_array)}
        columns={this.columns}
        pagination={
          {
            // 当前页
            current: pagination_store.page_cur,
            // 每页条数
            pageSize: pagination_store.page_size,
            // 总数据条数
            total: pagination_store.data_total,
            // 页码候选列表
            pageSizeOptions: pagination_store.page_size_options,
          }
        }
        onChange={
          (pagination, filters, sorter) => {
            let current = pagination.current;
            let page_size = pagination.pageSize;

            let order_by = undefined;
            if (sorter.columnKey !== undefined) {
              let desc = 0;
              if (sorter.order == 'descend') {
                desc = 1;
              }
              order_by = {
                order: sorter.columnKey,
                desc: desc
              }
            }

            this.pagination_callback(current, page_size, order_by);
          }
        }
      />
    )
  }
}

export default UserListTable;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/UserListTable.jsx